module.exports = __webpack_public_path__ + "img/universidad descartes.ee77db79.svg";